import type { ImageWithFallbackProps } from "@/components/image/ImageWithFallback";

export const SNACKBAR_IMAGE_PROPS: ImageWithFallbackProps = {
  width: 24,
  height: 24,
  alt: "string",
  src: "",
};
